import { googleGeocodeApiEndpoint } from '../config'

const GoogleGeocodeAPIHelper = () => {
  const getCoordsByAddress = async address => {
    if (!address || address.trim() === "") {
        return {};
    }
    const encodedAddress = encodeURIComponent(address)
    const apiUrl = `${googleGeocodeApiEndpoint}/byaddress/${encodedAddress}/`
    const result = await window.fetch(apiUrl, {
      // eslint-disable-next-line no-undef
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    return result.json()
  }
  return { getCoordsByAddress }
}

export default GoogleGeocodeAPIHelper()
